import type { ReactNode, ComponentType } from 'react';

export type TypographyTypes = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forwardedAs?: string | ComponentType<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: string | ComponentType<any>;
  children: ReactNode;
};

// eslint-disable-next-line no-shadow
export enum ParagraphType {
  Intro = 'intro',
  Large = 'large',
  Normal = 'normal',
  Small = 'small',
  CallToAction = 'call-to-action',
}
